module.exports = __webpack_public_path__ + "img/base_restauration_fast_food.07afd733.svg";